import * as React from "react";
import { useState, useEffect, useContext } from "react";
import listText from "../utils/dictionaries/dictionary-ine-consent";
import Checkbox from "../components/molecules/checkbox";
import Button from "../components/atoms/button";
import { useNavigate } from "react-router-dom";
import FormatTextPlain from "../components/organisms/format-text-plain";
import InformationTextUtilService from "../services/informationTextUtil.service";
import { GeneralInformationTextUseCase } from "../../application/use-cases/generalInformationText.usecase";
import Top from "../components/templates/top";
import Link from "../components/atoms/link";
import OtpUtilService from "../services/otpUtil.service";
import { ValidateCodeUseCase } from "../../application/use-cases/validateCode.usecase";
import { dateISO } from "../utils/helpers";
import { store } from "../redux/store";
import { useDispatch } from "react-redux";
import { changeNavigate, changeNextContinue } from "../redux/slices/navigateReducer";
import MessagesReactModal from "../components/templates/messages-react-modal";
import hexagonExclamationThin from "../assets/icons/hexagon-exclamation-thin.svg";
import ic_xclose from "../assets/icons/ic_xclose.svg";
import { useFollowLater } from "../hooks/useFollowLater";

const IneConsent = () => {
  const { onClickContinue } = useFollowLater();
  const state = store.getState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [isReadyData, setIsReadyData] = useState(false);
  const [somethingWentWrong, setSomethingWentWrong] = useState(false);
  const [textIneConsent, setTextIneConsent] = useState("");
  const [modalShow, setModalShow] = useState(false);

  const otpService = new OtpUtilService();
  const usecaseOtp = new ValidateCodeUseCase(otpService);

  const caseService = new InformationTextUtilService();
  const useCase = new GeneralInformationTextUseCase(caseService);

  const requestCode = (value: boolean) => {
    if(!somethingWentWrong)
      setChecked(!value);
  };

  const actionNext = async () => {
    setShowSpinner(true);
    const responseOtp = await usecaseOtp.sendOtp(
      {
        phone: state.client.dataPersist.phone,
        email: state.client.dataPersist.email,
        channel: "SMS",
        date: dateISO(),
      },
      state.client.clientPersist.uuid,
    );
    if (responseOtp.error != null) {
      setModalShow(true);
    } else {
      dispatch(
        changeNextContinue({
          nextContinue: "/CaptureINE",
          comeFrom: "IneConsent",
        }),
      );
      dispatch(
        changeNavigate({
          progressBarPercentage: "25%",
          editableValue: state.client.dataPersist.phone,
          typeValue: "phone",
          textButton: "Continuar",
          nextContinue: "/CaptureINE",
          comeFrom: "IneConsent",
        }),
      );
      onClickContinue({
        data: {...state.client.dataPersist },
        processId: state.client.clientPersist.uuid,
        resource: "ValidateCode",
        step: "CONTINUE",
      });
      navigate("/ValidateCode");
    }
    setShowSpinner(false);
  };

  useEffect(() => {
    const getInformation = async () => {
      setIsReadyData(false);
      const response = await useCase.ineConsent();
      if (response.error != null){
        setModalShow(true);
        setSomethingWentWrong(true)
      } else {
        setSomethingWentWrong(false)
      }
      setTextIneConsent(response.data);
      setIsReadyData(true);
    };
    getInformation();
  }, []);

  const followLaterAction = () => {
    navigate("/FollowLater", {
      state: {
        processId: state.client.clientPersist.uuid,
        resource: "IneConsent",
        step: "CONTINUE_AFTER",
        data: {...state.client.dataPersist}, // Agregar data del formulario
      },
    });
  };

  const functionProcessModal = () => {
    setModalShow(false);
    window.location.reload()
  };

  return (
    <>
      <div className="content-container">
        <Top
          titleHeader={"Apertura de cuenta"}
          subTitle={listText.text_2.mainText}
          displayProgressBar={""}
          displayLeftImageTitle={"d-none"}
          classTitleImage={""}
          classHeader={"mt-2"}
          styleHeader={{}}
          classProgressBar={"mt-3"}
          styleProgressBar={{}}
          classTitleAndImage={""}
          styleTitleAndImage={{}}
          valueProgressBar={"20%"}
          comeFrom={"/IneConsent"}
          onClickGoBackIcon={undefined}
        />
        <div className="p-3">
          <FormatTextPlain text={textIneConsent} type={"onlyDot"} />
          <Checkbox
            text={listText.text_4.mainText}
            htmlFor={"flexCheckDefault"}
            classNameLabel={"fs-6"}
            classCheckbox={"form-check mt-4 mb-4"}
            checked={checked}
            onChange={() => {
              requestCode(checked);
            }}
          />
        </div>
      </div>
      <div className="footer--pin">
        <Button
          text={listText.text_5.mainText}
          divClassName={"d-grid gap-2"}
          buttonClassName={`${
            showSpinner ? "pe-none" : ""
          } btn-bg-primary text-white w-100 place-content-center align-self-center`}
          spinner={showSpinner}
          onClick={() => {
            actionNext();
          }}
          disabled={!checked}
        />
        <div className="text-center mt-3">
          <Link
            text={"Seguir más tarde"}
            url={null}
            styleLink={{
              color: "#5A6172",
              lineHeight: "16px",
              textDecoration: "none",
              cursor: "pointer",
            }}
            onClick={followLaterAction}
            className={""}
          />
        </div>
      </div>
      <MessagesReactModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textTitle="¡Ups lo sentimos!"
        classTitle={"fw-bold"}
        styleTitle={{ color: "#00254A", fontSize: "20px", fontWeight: "700" }}
        listButtonsModal={[
          {
            text: "Reintentar",
            style: {},
            divClass: "",
            buttonClass: "button-enabled w-100 place-content-center align-self-center mt-3",
            spinner: false,
            onClick: () => {
              functionProcessModal();
            },
            disabled: false,
          },
        ]}
        imageModal={hexagonExclamationThin}
        onClickClose={() => setModalShow(false)}
        imageOnlyClose={ic_xclose}
        classContent={"ml-3 mr-3 mb-3 text-center"}
        classImageModal={"text-center my-4"}
        listParagraphs={[
          {
            textParagraph: "La aplicación no esta respondiendo debido a que hay problemas con la comunicación de nuestros sistemas.",
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
          {
            textParagraph: "Vuelve a intentar si el error persiste.",
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
        ]}
      />
    </>
  );
};

export default IneConsent;
